const browserRule = /^.*((iPhone)|(iPad)|(Safari))+.*$/;
const noop = () => {};
export function onIosBack(fn: Function) {
  if (browserRule.test(navigator.userAgent)) {
    const handle = (event: PageTransitionEvent) => {
      if (event.persisted) {
        fn();
        window.removeEventListener('pageshow', handle);
      }
    };
    window.addEventListener('pageshow', handle);
    return () => {
      window.removeEventListener('pageshow', handle);
    };
  }
  return noop;
}
